module.exports = __webpack_public_path__ + "static/media/fairTree.e5d8d9e0.svg";